var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import SSOClient from '@teliaee/telia-sso-client';
import { isDealerLoggingOutCustomer } from './store/SsoStore';
export default class SsoClientFactory {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "handleLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (newClientState) => {
                const { environmentStore: { app, isSPA }, ssoStore } = this.rootStore;
                if (!isSPA && ssoStore.isInitialized && newClientState.auth) {
                    if (!ssoStore.clientState.auth || (ssoStore.clientState.auth.authLevel === 1 && newClientState.auth.authLevel === 2)) {
                        if (newClientState.goto) {
                            ssoStore.setLoginCallback(() => (window.location.href = newClientState.goto));
                        }
                        else {
                            if (app !== 'online-help') {
                                ssoStore.setLoginCallback(() => window.location.reload());
                            }
                        }
                        ssoStore.setClientState(true, { ...newClientState, action: 'LegacyLogin' });
                        return;
                    }
                    if (isDealerLoggingOutCustomer(ssoStore.clientState, newClientState)) {
                        window.location.reload();
                        return;
                    }
                    ssoStore.setClientState(true, { ...newClientState, action: 'LegacyMandateChange' });
                }
                ssoStore.setClientState(true, newClientState);
                this.rootStore.externalCallbackStore.onClientStateChange(newClientState);
                this.rootStore.sectionStore.setSection(null);
                if (newClientState.goto) {
                    window.location.assign(newClientState.goto);
                }
            }
        });
        Object.defineProperty(this, "handleLogout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { ssoStore } = this.rootStore;
                ssoStore.setClientState(true, { action: 'logout' });
                this.rootStore.externalCallbackStore.onClientStateChange(null);
                this.rootStore.sectionStore.setSection(null);
            }
        });
        Object.defineProperty(this, "createClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { lang, tier } = this.rootStore.environmentStore;
                const client = SSOClient.connect({ onLogin: this.handleLogin, onLogout: this.handleLogout, env: tier }, { locale: lang });
                client.loadInitialState();
                return client;
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
    }
}
__decorate([
    action
], SsoClientFactory.prototype, "handleLogout", void 0);
//# sourceMappingURL=SsoClientFactory.js.map